module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--sp@2-0f2a5e9895ede5c7455ad2166dc65964.jpg";